'use strict';

/**
 * Module dependencies
 */
var angular = require('angular');

module.exports = angular
  .module('app.core-utilities-implementation', [
    require('./aws-api').name,
    require('./device-services').name,
    require('./dynamic-header-buttons').name,
    require('./filters').name,
    require('./ionic-delegates').name,
    require('./ionic-keyboard').name,
    require('./push-notifications').name,
    require('./upload-service').name
  ]);


// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/index.js